import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';

import { SearchResultsStore } from 'stores/search-results-store';

import { OverFilteredModel } from 'models';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';

import { DoubleLink } from 'components/common/media/double-link';

export interface OverFilterProps {
  analytics?: AnalyticsStore;
  overFilteredModel: OverFilteredModel;
  searchResults?: SearchResultsStore;
  routeStore?: RouteStore;
  isLoading?: boolean;
}

const LinkTracked = ClickTracker(DoubleLink);

export const OverFilter: React.FunctionComponent<OverFilterProps> = inject('routeStore')(
  ({ analytics, isLoading, overFilteredModel, searchResults, routeStore }) => {
    React.useEffect(() => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent('OverFilter.Display', 'Display', analytics.omnitureData);
      }
    }, []);

    if (
      isLoading ||
      !overFilteredModel ||
      !overFilteredModel.overFilteredContent ||
      !overFilteredModel.overFilteredContent.titleModel ||
      !overFilteredModel.overFilteredContent.subtitleModel ||
      !overFilteredModel.overFilteredContent.actionModel
    ) {
      return null;
    }

    const { titleModel, subtitleModel, actionModel } = overFilteredModel.overFilteredContent;

    const { icon, text: heading } = titleModel;
    const { text: body } = subtitleModel;
    const { primary } = actionModel;

    const clearFilters = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      searchResults.clearFilters(routeStore);
    };

    return (
      <>
        <UitkMessagingCard imageLayout={UitkMessagingCardImageLayout.LEFT} className="all-t-margin-three">
          {icon && (
            <UitkMessagingCardMedia>
              <UitkFigure ratio={UitkFigureAspectRatioType.R1_1} src={icon} />
            </UitkMessagingCardMedia>
          )}
          <UitkMessagingCardSection heading={heading}>
            {body && <p className="uitk-type-300 pwa-theme--grey-700">{body}</p>}
            {primary &&
              primary.text && (
                <LinkTracked
                  linkName="overFilter.removeAllFilter"
                  rfrr=".OverFilter.RemoveAllFilter"
                  onClick={clearFilters}
                  className="all-cell-align-top all-t-padding-two"
                >
                  {primary.text}
                </LinkTracked>
              )}
          </UitkMessagingCardSection>
        </UitkMessagingCard>
        {overFilteredModel.overFilteredTitle && (
          <h3 className="uitk-type-500 all-t-margin-six" data-stid="over-filter-header">
            {overFilteredModel.overFilteredTitle}
          </h3>
        )}
      </>
    );
  }
);

OverFilter.displayName = 'OverFilter';
